import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { randomNumber } from "utils/math";
import { StyledUniverseStarComponent } from "./universe-star-component.scss";
const UniverseStarComponent = (props)=>{
    const { isCircle, leftRange, rightRange, left, top, right } = props;
    const getStarSize = ()=>{
        return `${randomNumber(leftRange, rightRange)}px`;
    };
    const getTwinkleDuration = ()=>{
        return `${Math.ceil(randomNumber(1, 3))}s`;
    };
    const getTwinkleDelay = ()=>{
        return `${Math.ceil(randomNumber(1, 8))}s`;
    };
    const getStyle = ()=>{
        return {
            left,
            top,
            right,
            "--star-size": getStarSize(),
            "--twinkle-duration": getTwinkleDuration(),
            "--twinkle-delay": getTwinkleDelay()
        };
    };
    return /*#__PURE__*/ _jsx(StyledUniverseStarComponent, {
        className: classNames("universe-star", {
            circle: isCircle
        }),
        style: getStyle()
    });
};
export default UniverseStarComponent;
